import { Amplify, Auth } from 'aws-amplify';
import awsconfig from './aws-exports';

if (typeof COGNITO_CUSTOM_DOMAIN !== 'undefined' && COGNITO_CUSTOM_DOMAIN !== 'default') {
  // Force update Cognito Settings for custom domain
  // refs https://github.com/aws-amplify/amplify-cli/issues/1880
  awsconfig.oauth.domain = COGNITO_CUSTOM_DOMAIN;
}
Amplify.configure(awsconfig);

// Cognito Hosted UI configuration
// const oauth = {
//     domain: 'backend-services-userpool-dev.auth.us-east-1.amazoncognito.com',
//     scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
//     redirectSignIn: 'http://localhost:3000/',
//     redirectSignOut: 'http://localhost:3000/',
//     responseType: 'code', // or 'token', note that REFRESH token will only be generated when the responseType is code
// }

// Auth.configure({ oauth })

const cognitoUserPoolId = awsconfig.aws_user_pools_id;

const cognitoUserPoolClientId = awsconfig.aws_user_pools_web_client_id;

// aws-exports.js is written by `amplify pull`, and its shape depends on how far the backend
// environment had deployed when that pull ran. A pull that races the CloudFormation stack, as
// happens on the first pipeline of a new MR, returns a config carrying nothing but
// aws_project_region. Without this check the next line reads `.substring` off undefined and the
// app — and every test, since tests/global/setup.ts imports backendId — dies with a bare
// TypeError that names neither the file nor the cause. aws-exports.d.ts promises a real error
// at the use site if a field is missing at runtime; this is that error.
if (!cognitoUserPoolId) {
  throw new Error(
    'aws-exports has no aws_user_pools_id, so the Cognito backend had not finished deploying ' +
      'when `amplify pull` ran. Re-run fetch-amplify-backend-and-compile-ts once the Amplify ' +
      'build for this commit has finished. This is an environment problem, not a code change.',
  );
}

const backendId = cognitoUserPoolId.substring(cognitoUserPoolId.lastIndexOf('_') + 1).toLowerCase();

const isLocalMock = awsconfig.aws_appsync_dangerously_connect_to_http_endpoint_for_testing === true;

export { Amplify, Auth, cognitoUserPoolId, cognitoUserPoolClientId, backendId, isLocalMock };
